import { RouteType } from "types/RouteType";
import AssignmentDetailStore from "./AssignmentDetailStore";

/**
 * **Action Item** — `/app/assignments/:id`, one assignment: what it is, who
 * holds it, its Azure DevOps work item and, once it ships, its PR.
 *
 * THIS IS A NOTIFICATION TARGET. Every action-item notice HQ sends links here
 * through the API's ONE helper (`packages/api/src/services/read-ai/
 * assignment-link.ts`, `/app/assignments/<id>`): new work in your queue,
 * completion evidence filed, and the four-audience "it shipped" notice. The
 * layout + path below and that helper are pinned to the same literal on both
 * sides (assignmentDetail.Route.test.ts, completion-notice.test.ts) — change
 * one and a test goes red. Before this route existed those notices linked to
 * `/read-ai/assignments/<id>`, which matched nothing.
 *
 * Read-only, and readable by every audience the notice reaches: the API's
 * `read-ai-assignments` get is `requireStaff()`, so any signed-in staff account
 * may open it. No `requiresPermission` here for the same reason. Hidden from
 * the nav — it is reached from a link, like Meeting Detail.
 */
const assignmentDetailRoute: RouteType[] = [
  {
    name: "AssignmentDetail",
    path: "/assignments/:id",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Action Item",
        enableRefreshButton: true,
        // Names the item beside "Action Item" (walkthrough #10 / §2.3).
        component: () => import("./AssignmentDetail.Header"),
      },
      body: {
        component: () => import("./AssignmentDetail.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    hidden: true,
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore, params }) => {
      const store = rootStore.assignmentDetailStore as AssignmentDetailStore;
      store.setAssignmentId(params.id as string);
      void store.load();
    },
    onParamsChange: ({ rootStore, params }) => {
      const store = rootStore.assignmentDetailStore as AssignmentDetailStore;
      const next = Number(params.id);
      if (store.assignmentId !== next) {
        store.setAssignmentId(params.id as string);
        void store.load();
      }
    },
    onExit: ({ rootStore }) => {
      const store = rootStore.assignmentDetailStore as AssignmentDetailStore;
      store?.reset();
    },
  },
];

export default assignmentDetailRoute;
